/***************************************************************************************
 * FileName      : SensorType.ts
 * Description   : 센서 유형 상수, 타입, 표시 정보 (JSON sensorType 필드)
 * Author        : (주)한국공학기술연구원 박은정
 * Created Date  : 2026.02.10
 * Modified Date :
 * Reference     : packages/scjeil-smart_ict_lab-app/assets/json/equipment/*.json → devices[].sensors[].sensorType
 ***************************************************************************************/

// 2026.02.10 : 박은정 : 센서 유형 알려진 값 (확장 가능성 중간 → const + type)
// → 새 센서 유형(예: Humidity, Vibration) 추가 시 여기에 값만 추가
export const SensorTypes = {
  Temperature: 'Temperature',
  Pressure: 'Pressure',
  Flow: 'Flow',
  Level: 'Level',
  Concentration: 'Concentration',
} as const;

export type SensorType = (typeof SensorTypes)[keyof typeof SensorTypes] | string;

// ─────────────────────────────────────────────────────────────────────────────
//  센서 유형별 표시 정보 (헤딩, 순서)
// ─────────────────────────────────────────────────────────────────────────────

// 2026.02.10 : 박은정 : sensorType → 한국어 그룹 헤딩 매핑 (모니터링 카드 표시용)
export const SENSOR_TYPE_HEADINGS: Record<string, string> = {
  [SensorTypes.Temperature]: '온도 (Temperature)',
  [SensorTypes.Pressure]: '압력 (Pressure)',
  [SensorTypes.Flow]: '유량 (Flow Rate)',
  [SensorTypes.Level]: '수위 (Level)',
  [SensorTypes.Concentration]: '🧪 농도 (Concentration)',
};

// 2026.02.10 : 박은정 : sensorType 표시 순서 (우선순위)
export const SENSOR_TYPE_ORDER: string[] = [
  SensorTypes.Temperature,
  SensorTypes.Pressure,
  SensorTypes.Flow,
  SensorTypes.Level,
  SensorTypes.Concentration,
];

